import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-black text-white fixed w-full z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/"><img src="/assets/logo.png" alt="Logo" className="h-10" /></Link>
        
        {/* Menu Desktop */}
        <nav className="hidden md:flex space-x-6">
          <Link to="/" className="hover:text-orange-500">Accueil</Link>
          <Link to="/vehicules" className="hover:text-orange-500">Nos Véhicules</Link>
          <Link to="/about" className="hover:text-orange-500">À Propos</Link>
          <Link to="/contact" className="hover:text-orange-500">Contact</Link>
        </nav>

        {/* Bouton Mobile */}
        <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}>
          <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
      </div>

      {/* Menu Mobile ouvert */}
      {isOpen && (
        <div className="md:hidden bg-zinc-900 p-4 flex flex-col space-y-3">
          <Link to="/" onClick={() => setIsOpen(false)}>Accueil</Link>
          <Link to="/vehicules" onClick={() => setIsOpen(false)}>Nos Véhicules</Link>
          <Link to="/about" onClick={() => setIsOpen(false)}>À Propos</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
        </div>
      )}
    </header>
  );
};

export default Header;
